export const urlContainsSegment = (url: string, segment: string): boolean => url.includes(segment);
